import { motion } from 'motion/react';

interface BrandHeroProps {
  compact?: boolean;
}

export function BrandHero({ compact = false }: BrandHeroProps) {
  const logoSize = compact ? 'w-16 h-16' : 'w-22 h-22';

  return (
    <motion.div
      className="flex flex-col items-center"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {/* Logo with pulsing glow */}
      <div className="relative mb-3">
        {/* Glow ring */}
        <motion.div
          className="absolute inset-0 rounded-full bg-[#8bc43e]"
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.3, 0, 0.3],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeOut',
          }}
        />
        {/* Logo image */}
        <img
          src="./eveebuddy-logo.png"
          alt="EVee Buddy"
          className={`${logoSize} relative z-10 drop-shadow-lg`}
        />
      </div>

      {/* Brand name */}
      <h2 className={`${compact ? 'text-xl' : 'text-2xl'} font-bold text-foreground`}>
        EVee Buddy
      </h2>

      {/* Tagline - hidden in compact mode */}
      {!compact && (
        <p className="text-xs text-muted-foreground mt-0.5">for a worry free travel!</p>
      )}
    </motion.div>
  );
}
